/**
 * Boilerplate.js
 */

import $ from 'jquery';
import { gsap, Power2 } from 'gsap/all';

export default class StackingCards {

    constructor(element) {

        if ( window.innerWidth < 768 ) {
            return;
        }

        this.fnmap = {
            'toggle': 'toggle',
            'show': 'add',
            'hide': 'remove'
        };
        this.element = element;
        this.collapses = $('[data-toggle="card-collapse"]', this.element);
        this.cards = $('[data-card-toggle-item]', this.element);
        this.collapse = this.collapse;
        this.stackItems = $('.stack__item', this.element);
        this.wrapper = $('.stack-wrapper', this.element);
        this.container = $('.card-stack-container', this.element).get(0);
        this.elementsMargin = 30;
        this.positions = [];
        this.bindEvents();
    }

    bindEvents() {

        this.collapses.on('click focus', this.setActiveCard.bind(this));
        this.cards.each((index, el)=>{
          const $el = $(el);
          $el.on('mouseenter', () => {
              if(gsap.getTweensOf(el).length < 1){
                  const zIndex = parseInt(el.style.zIndex);
                  if(zIndex < this.stackItems.length){
                    gsap.to(el, {top: 20, left: 20, duration: .3, ease: Power2.easeOut});
                  }
              }
          });
          $el.on('mouseleave', () => {
            el.tween = gsap.to(el, {top: 0, left: 0, duration: .3, ease: Power2.easeOut});
          })
        })

        // Sets up the stack visually
        this.setupStack();

        let classFunction = this;
        this.stackItems.each( (index, item) => {
            item.addEventListener('click', function() {
                const target = this;
                classFunction.clickIndividualCard(target);
            });
        })

       window.addEventListener('resize', this.setupStack.bind(this));

    }

    clickIndividualCard(target) {
        const text = target.getAttribute('data-card-toggle-item');
        const accordionButton = $(`[data-card-toggle="${text}"]`, this.element);
        if ( accordionButton.parent().hasClass('show') ) {
            return;
        }
        accordionButton.trigger('click')
    }

    setActiveCard(evt) {
        const $el = $(evt.target).closest('[data-toggle="card-collapse"]');
        const activateCard = this.cards[$el.attr('data-card-toggle') - 1];
        const parent = $el.parent().get(0);
        this.sortCards(activateCard);
        this.collapse(parent, 'toggle');
    }

    sortCards(card) {
        gsap.killTweensOf(card);
        let {x, y, zIndex} = this.positions[0];
        gsap.set(card, {zIndex});
        gsap.to(card, {duration:.3, x, y, ease: Power2.easeOut })
        let positionIndex = 1;
        this.stackItems.each((i, el) => {
            if (el !== card) {
                ({x, y, zIndex} = this.positions[positionIndex]);
                gsap.killTweensOf(el);
                gsap.set(el, {zIndex});
                gsap.to(el, {duration:.3, x, y, ease: Power2.easeOut })
                positionIndex++;
            }
        })
    }

    collapse(selector, cmd) {
        this.collapses.each((index, element) => {
            var target = $(element).parent('.collapse-wrapper').get(0);
            if ( target === selector ) {
                if (target.classList.contains('show')) {
                    let card = this.cards[element.getAttribute('data-card-toggle') - 1]
                    // $(element).on('keydown', (e)=> { this.tabToCard(e, card) });
                } else {
                    target.classList.add('show')
                }
            } else {
                target.classList.remove('show')
            }
        });
    }

    setupStack() {
        const isMobile = window.innerWidth < 768;
        const timeline = gsap.timeline({
          scrollTrigger: {
            trigger: this.stackItems[0],
            start: "top 100%",
          }
        });
        let cardHeight;

        this.stackItems.each((i, card) => {
          let position = {
            x: isMobile ? 0 : this.elementsMargin * i,
            y: isMobile ? 0 : this.elementsMargin * i,
            zIndex: this.stackItems.length - i,
          };
          const {x,y, zIndex} = position;
          gsap.set(card, {zIndex});
          timeline.to(card, {duration:.3, x, y, ease: Power2.easeOut }, i * .15);
          cardHeight = card.offsetHeight;
          this.positions.push(position);
        })
        this.container.style.height = isMobile ? 'auto' :`${(cardHeight + (this.stackItems.length * this.elementsMargin)) }px`;
    }

}

